import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda03 = () => {

  return (<>
    <PageHeader
    title="Scheda 03"
    description="CRITERI ANALISI MATERIALITÀ E STRATEGICA AZIENDA PER LA SOSTENIBILITÀ"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>Secondo l’<strong>analisi del contesto</strong> suggerito dalla EFRAG per l’<strong>analisi di materialità</strong> (FASE A) l’azienda provvederà a delineare una <strong>panoramica</strong> relativa a:</p>
            <ul>
              <li>a) analisi del piano aziendale, della strategia, del contesto giuridico e della documentazione pubblicata</li>  
              <li>b) attività, prodotti e servizi della azienda e ubicazione geografica delle attività</li>
              <li>c) mappatura dei rapporti commerciali a monte ed a valle della catena del valore e degli stakeholder</li>
              <li>d) identificazione del perimetro delle informazioni da rendicontare al di fuori della propria operatività</li>
            </ul>

            <p>Il <strong>risultato di questa panoramica</strong> darà all’azienda gli <strong>input</strong> necessari per individuare <strong>gli impatti, i rischi e le opportunità (IRO – secondo i principi ESRS)</strong> associati ad ogni <strong>ambito di intervento principale</strong>, con ricadute <strong>positive e negative</strong> per gli <strong>stakeholder e per l’azienda</strong>, sotto le tre dimensioni dell’<strong>ambiente</strong>, della <strong>governance</strong> e del <strong>sociale</strong>, da considerare nel <strong>report di sostenibilità</strong>.</p>
            <br/>
            <p>Inoltre l’azienda evidenzierà le <strong>certificazioni ottenute nel campo della sostenibilità</strong>.</p>
            <br/>
            <p>In questo modo potranno essere definiti gli <strong>obiettivi dell’azienda</strong> ed i <strong>piani di azione</strong> che individueranno la <strong>strategia</strong> della stessa azienda <strong>per la sostenibilità</strong> e forniranno le linee guida per le fasi successive di identificazione degli impatti, rischi ed opportunità IRO di mitigazione degli stessi rischi (EFRAG FASE B) e la valutazione della loro importanza e della loro performance attraverso appositi KPI e metriche (EFRAG FASE C).</p>
            <p>Questa analisi servirà anche per una prima selezione da parte della azienda degli stakeholder e degli ambiti di intervento principali da considerare partendo dall’elenco della proposta base degli stakeholder/ambiti individuati in ALLEGATI 1 e 2</p>
            <p>Questa prima selezione degli stakeholder e ambiti principali potrà essere eventualmente rivista e affinata dopo la TERZA FASE C EFRAG di valutazione della rilevanza dei rischi e loro mitigazioni per KPI relative agli impatti e opportunità in termini di valore condiviso. In questo modo si potrà pervenire ad una selezione definitiva degli stessi che ottimizzi anche economicamente, sia per gli stakeholder interessati sia per l’azienda, la gestione complessiva della sostenibilità da parte dell’azienda ed allo stesso tempo le fornisca gli elementi utili per la rendicontazione secondo le norme CSRD.</p>

          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda03;
